import { getXPreferredLanguage } from '../../helpers/misc';

export function getHeaders() {
  const adminToken = localStorage.getItem('x-auth-admin');

  return {
    'content-type': 'application/json',
    'x-preferred-language': getXPreferredLanguage(),
    ...(adminToken ? { 'x-auth': adminToken } : undefined),
  };
}

export default getHeaders;
